import styled from 'styled-components';
export const Container = styled.fieldset `
  padding: 0;

  & & {
    padding-top: 8px;
    padding-left: 36px;
  }
`;
